
/**
 * Created by nijin on 8/9/17.
 */
import { Component, OnInit } from '@angular/core';
import {environment} from "../../../../environments/environment";
import {GoogleAnalyticsEventsService} from "../../../core/googleAnalyticsService";

@Component({
    selector: 'nuc-electron-details',
    templateUrl: './electron-details.component.html'
})
export class ElectronDetailsComponent implements OnInit {
  tabs: Array<any> = [{active: false}, {active: false}, {active: false}];
  downloadLinks: any;
  constructor(private googleAnalyticsEventsService: GoogleAnalyticsEventsService) {
    this.downloadLinks = environment.electronDownloadLinks;
  }

  ngOnInit() {
  }

  selectTab(index: number) {
    // deactivate all tabs
    this.tabs.forEach(tab => tab.active = false);

    // activate the tab the user has clicked on.
    this.tabs[index].active = true;
  }

  sendGaEvent(){
    this.googleAnalyticsEventsService.emitEvent('Download','click','ElectronDownload');
  }

}



// WEBPACK FOOTER //
// ./src/app/site/platform/electron/electron-details.component.ts